import {BoarderState, GlobalState} from '@/types/state'
import * as actionTypes from '@/store/action-types'

import axios from '@/plugins/axios'
import BoarderGroup, {
  BoarderGroupResponse,
  BoarderGroupResponseModel
} from '@/model/boarder/BoarderGroup'
import {BoarderCalendarResponseItem, BoarderResponse, MyLatestInvoiceResponse} from '@/types/service-response'
import {
  BoarderArchivePayload,
  BoarderCalendarPayload, BoarderGroupPayload,
  CreateNewBoarderPayload,
  MoveBoarderToGroupPayload
} from '@/types/payload'
import moment from 'moment'
import {AxiosResponse} from "axios";
import {FETCH_ARCHIVED_BOARDER_LIST, REMOVE_BOARDER_FROM_ARCHIVE} from "@/store/action-types";

const state: BoarderState = {}

const getters = {}

const mutations = {}

const actions = {
  async [actionTypes.BOARDER_FETCH_BOARDER_GROUP_LIST]({rootState}: { rootState: GlobalState }): Promise<BoarderGroup[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/boarder-group`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    return BoarderGroup.createFromResponse(response.data as BoarderGroupResponse)
  },

  async [actionTypes.BOARDER_FETCH_BOARDER_GROUP_LIST_AS_INTERFACE]({rootState}: { rootState: GlobalState }): Promise<BoarderGroupResponseModel[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/boarder-group`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    return response.data
  },

  async [actionTypes.BOARDER_UPDATE_BOARDER_GROUP]({rootState}: { rootState: GlobalState }, payload: BoarderGroupPayload): Promise<BoarderGroupResponseModel> {
    const response = await axios.put(`/api/boarder-group/${payload.id}`, payload, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    return response.data
  },

  async [actionTypes.BOARDER_FETCH_LIST]({rootState}: { rootState: GlobalState }): Promise<BoarderResponse> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/food-ordering/boarder`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    })

    return response.data as BoarderResponse
  },

  async [actionTypes.BOARDER_FETCH_CALENDAR]({rootState}: { rootState: GlobalState }, payload: BoarderCalendarPayload): Promise<BoarderCalendarResponseItem[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/food-ordering/boarder/${payload.boarderId}/calendar`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },

      params: {
        start: moment(payload.start).format('YYYY-MM-DD'),
        end: moment(payload.end).format('YYYY-MM-DD')
      }
    })

    return response.data
  },

  async [actionTypes.BOARDER_ARCHIVE]({rootState}: { rootState: GlobalState }, payload: BoarderArchivePayload): Promise<BoarderResponse[]> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.post(`/api/${tenantCode}/boarder/archive`, {
      boarderIdList: payload.boarderIdList
    }, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    })

    return response.data
  },

  async [actionTypes.BOARDER_MOVE_TO_GROUP]({rootState}: { rootState: GlobalState }, payload: MoveBoarderToGroupPayload): Promise<BoarderGroupResponse> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code
    const response = await axios.post(`/api/boarder/batch-move-to-group`, payload,
     {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    })

    return response.data
  },

  async [actionTypes.BOARDER_CREATE]({rootState}: { rootState: GlobalState }, payload: CreateNewBoarderPayload): Promise<void> {
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.post(`/api/${tenantCode}/boarder`, {
      firstName: payload.firstName,
      familyName: payload.familyName,
      emailList: payload.emailList,
      phoneNumberList: payload.phoneNumberList,
      customer: payload.customer.id,
      boarderGroup: payload.boarderGroup.id
    }, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
    })

    return response.data
  },

  async [actionTypes.BOARDER_DOWNLOAD_QR_FILE]({rootState}: { rootState: GlobalState }, payload: BoarderResponse[]): Promise<void> {
    const ids = payload.map(b => b.id)
    const tenantCode: string = rootState.auth.currentUser!.tenant.code

    const response = await axios.get(`/api/${tenantCode}/boarder/qr-code-file`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      params: {
        'boarder-id': ids.join(';')
      },
      responseType: 'blob'
    })

    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
    const fileLink = document.createElement('a');

    fileLink.style.display = 'none'
    fileLink.href = fileURL;
    fileLink.setAttribute('download', moment().format('YYYY-MM-DD-qr.pdf'));
    document.body.appendChild(fileLink);

    fileLink.click();
  },

  async [actionTypes.FETCH_ARCHIVED_BOARDER_LIST] ({  }): Promise<any[]> {
    const response = await axios.get(`/api/boarder/archive`)
    return response.data
  },

  async [actionTypes.REMOVE_BOARDER_FROM_ARCHIVE] ({  }, payload: any): Promise<void> {

    const response = await axios.delete(`/api/boarder/archive/${payload.id}`)

    return response.data

  },
}

const boarderModule = {
  state,
  getters,
  mutations,
  actions
}

export default boarderModule
